import { type EntityType } from '../types'

type WorkflowScope = 'workflow' | 'status'

export const queryKeys = {
  assignmentById: (
    workflowId: string,
    stageId: string,
    assignmentId: string
  ) => [...queryKeys.assignmentsByStage(workflowId, stageId), assignmentId],
  assignmentsByStage: (workflowId: string, stageId: string) => [
    ...queryKeys.stageByWorkflow(workflowId, stageId),
    'assignments',
  ],
  assignmentListByStage: (workflowId: string, stageId: string) => [
    ...queryKeys.assignmentsByStage(workflowId, stageId),
    'list',
  ],
  responsesByAssignment: (
    workflowId: string,
    stageId: string,
    assignmentId: string
  ) => [
    ...queryKeys.assignmentById(workflowId, stageId, assignmentId),
    'responses',
  ],
  responseById: (
    workflowId: string,
    stageId: string,
    assignmentId: string,
    responseId: string
  ) => [
    ...queryKeys.responsesByAssignment(workflowId, stageId, assignmentId),
    responseId,
  ],
  singleAssignment: (
    workflowId: string,
    stageId: string,
    assignmentId: string
  ) => [
    ...queryKeys.assignmentById(workflowId, stageId, assignmentId),
    'assignment',
  ],
  singleResponse: (
    workflowId: string,
    stageId: string,
    assignmentId: string,
    responseId: string
  ) => [
    ...queryKeys.responseById(workflowId, stageId, assignmentId, responseId),
    'response',
  ],
  stageByWorkflow: (workflowId: string, stageId: string) => [
    ...queryKeys.workflowById(workflowId),
    'stage',
    stageId,
  ],
  userByWorkflow: (workflowId: string) => [workflowId, 'users'],
  userById: (workflowId: string, userId: string) => [
    ...queryKeys.userByWorkflow(workflowId),
    userId,
  ],
  workflowById: (workflowId: string) => ['workflow', workflowId],
  workflowByEntity: (
    entityType: EntityType,
    entityId: string,
    scope?: WorkflowScope
  ) => (scope ? [entityType, entityId, scope] : [entityType, entityId]),
}
